module.exports = __webpack_public_path__ + "img/icon_map_4_on_011.5f303206.png";